import { EXPRESS_API } from 'configs/api/expressApi';

export const getGraphAuthUrl = async () => {
  const response = await EXPRESS_API.get(`/microsoft-graph/auth-url`);
  return response.data;
};
